import { makeActionCreator } from '../../../utilities'
import { LoginConstants } from './login.constants'

export const resetLogin = makeActionCreator(LoginConstants.RESET_LOGIN)
export const setLoginFailed = makeActionCreator(LoginConstants.SET_LOGIN_FAILED, 'loginFailed')
export const setAuthenticationJwt = makeActionCreator(LoginConstants.SET_AUTHENTICATION_JWT, 'authenticationJwt')
export const setLoginPhaseIsLoading = makeActionCreator(
  LoginConstants.SET_LOGIN_PHASE_IS_LOADING,
  'loginPhaseIsLoading'
)
export const setUserVerifyErrorText = makeActionCreator(
  LoginConstants.SET_USER_VERIFY_ERROR_TEXT,
  'userVerifyErrorText'
)
export const setLoginCallbackUrl = makeActionCreator(LoginConstants.SET_LOGIN_CALLBACK_URL, 'loginCallbackUrl')
